export const calculateFieldErosion = {
    getFieldErosion
};

function getFieldErosion(field, percent, type, total, fieldsLength, i) {
    let filedCode = field.code.toLowerCase();
    let value = percent;

    if (type === 'GOOD' || type === 'SATISFACTORY' || type === 'DISSATISFIED') {

        if (filedCode.search('foundation') !== -1) {
            value = percent / 2;
        } else if (filedCode.search('wall') !== -1) {
            value = percent * 1;
        } else if (filedCode.search('house_cover') !== -1) {
            value = percent / 1.2;
        } else if (filedCode.search('roof') !== -1 || filedCode === 'house_top' || filedCode === 'carpet') {
            value = percent / 1.1;
        } else if (filedCode.search('floor') !== -1) {
            value = percent * 1.3;
        } else if (filedCode.search('punching_operations') !== -1) {
            value = percent * 1.2;
        } else if (filedCode.search('window') !== -1 || filedCode.search('door') !== -1) {
            value = percent / 1.5;
        } else if (filedCode.search('electric') !== -1 || filedCode.search('devices') !== -1 || filedCode.search('sanitary') !== -1) {
            value = percent * 1.4;
        }

    } else if (type === 'ACCIDENT_STATE') {

        if (filedCode.search('foundation') !== -1) {
            value = percent / 1.2;
        } else if (filedCode.search('wall') !== -1) {
            value = percent * 1;
        } else if (filedCode.search('house_cover') !== -1) {
            value = percent / 1.2;
        } else if (filedCode.search('roof') !== -1 || filedCode === 'house_top' || filedCode === 'carpet') {
            value = percent / 1.1;
        } else if (filedCode.search('floor') !== -1) {
            value = percent * 1.05;
        } else if (filedCode.search('punching_operations') !== -1) {
            value = percent * 1.2;
        } else if (filedCode.search('window') !== -1 || filedCode.search('door') !== -1) {
            value = percent / 1.05;
        } else if (filedCode.search('electric') !== -1 || filedCode.search('devices') !== -1 || filedCode.search('sanitary') !== -1) {
            value = percent * 1.1;
        }

    } else if (type === 'UNUSABLE') {

        if (filedCode.search('foundation') !== -1) {
            value = percent / 1.1;
        } else if (filedCode.search('wall') !== -1) {
            value = percent * 1.02;
        } else if (filedCode.search('house_cover') !== -1) {
            value = percent * 1.03;
        } else if (filedCode.search('roof') !== -1 || filedCode === 'house_top' || filedCode === 'carpet') {
            value = percent * 1.035;
        } else if (filedCode.search('floor') !== -1) {
            value = percent * 1.02;
        } else if (filedCode.search('punching_operations') !== -1) {
            value = percent * 1.04;
        } else if (filedCode.search('window') !== -1 || filedCode.search('door') !== -1) {
            value = percent / 1.05;
        } else if (filedCode.search('electric') !== -1 || filedCode.search('devices') !== -1 || filedCode.search('sanitary') !== -1) {
            value = percent * 1.02;
        }
    }

    if ((fieldsLength - 1) === i) {
       value = (fieldsLength * percent) - total;
    }
    return value;
}